import React from "react";

const CharCounterMC = ({
  className = '',
  counter = 0,
  limit = 0
}) => (
  <span className={`tw-absolute tw-right-[25px] tw-bottom-2.5 tw-text-xs tw-text-gray-500 tw-text-right ${className}`}>
    <span>{counter}</span>
    /
    {limit}
  </span>
);

export default CharCounterMC;
